import React, { useState, useEffect } from "react";
import plusWhite from "../../assets/images/plus-white.svg";
import { useFormik } from "formik";
import "react-dates/initialize";
import "react-dates/lib/css/_datepicker.css";
import "../../styles/style.css";
import "../../styles/payout.css";
import "../../styles/upi-mandate.css";
import { TabPanel, Tabs } from "react-tabs";
import moment from "moment";
import {
  completeBuyerBid,
  fetchBuyerRequestList,
  reviceBuyerReuest,
  updateBuyerBid,
} from "../../action/buyer";
import Offcanvas from "react-bootstrap/Offcanvas";
import { toast } from "react-hot-toast";
import { SingleErrorMessage } from "../singleErrorMessage";
import Modal from "react-bootstrap/Modal";
import { Loader } from "../../components/loader";
import Pagination from "../../components/pagination/paginationView";
import { handleCurrency, handleTitle } from "../../helper/helper";
import Breadcrumb from "../../components/Breadcrumb/Breadcrumb";
import { useNavigate, useParams } from "react-router-dom";
import { changeWarhouseBidStatus } from "../../action/warehouse";
import { SearchBox } from "../../components/SearchBox";

export const BuyerConfirmRequestList = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [buyerReuqstList, setBuyerReuqstList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [paginationValue, setPaginationValue] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [isUpdateOpenModal, setIsUpdateOpenModal] = useState(false);
  const [warehouseId, setWarehouseId] = useState("");
  const [status, setStatus] = useState(1);
  const [isLoading, setIsLoading] = useState(true);
  const [warehouseIds, setWarehouseIds] = useState([]);
  const [filteredList, setFilteredList] = useState(0);
  const [isOpenCancelModal, setIsOpenCancelModal] = useState(false);
  const [search, setSearch] = useState();
  const fetchBuyerList = async (searchValue = "") => {
    setIsLoading(true);
    const response = await fetchBuyerRequestList(
      currentPage,
      paginationValue,
      1,
      id,
      searchValue
    );
    if (response.status) {
      const warehouseIdsArray = [
        ...new Set(
          response?.data?.list.map((buyer) => buyer?.warehouseDetails?._id)
        ),
      ];

      const list = response.data?.list;
      const uniqueIds = [...new Set(list.map((item) => item))];
      const confirmRequests = uniqueIds.filter(
        (item) =>
          item?.warehouseDetails?.status === 1 ||
          item?.warehouseDetails?.status === 5
      ).length;

      setFilteredList(confirmRequests);
      setWarehouseIds(warehouseIdsArray);
      setBuyerReuqstList(response.data.list);
      setTotalRecords(response.data.count);
      setIsLoading(false);
    }
  };

  const onCloseToaste = () => {
    toast.dismiss();
  };

  //complete parent(buyer) request if all request completed, cacelled or reviced
  const handleCompleteWarehouseBid = async () => {
    const payload = {
      status: 2,
    };
    // const response = await completeBuyerBid(id, payload);
    const response = await updateBuyerBid(id, payload);
    if (response.status) {
      toast.custom(
        <SingleErrorMessage
          data={response.message}
          error={false}
          bColor="#175FC9"
          onClose={onCloseToaste}
        />
      );

      // navigate("/buyerReqest/list", { state: { id: 3 } });
      navigate("/buyerReqest/closed-request");
    } else {
      toast.custom(
        <SingleErrorMessage
          data={response.message}
          error={true}
          bColor="#D92D20"
          onClose={onCloseToaste}
        />
      );
    }
  };

  const handleUpdateBid = async () => {
    const payload = {
      status: 2,
    };
    const response = await changeWarhouseBidStatus(warehouseId, payload);
    if (response.status) {
      if (filteredList == 1) {
        handleCompleteWarehouseBid();
      } else {
        handlePartialCompleteBid();
        fetchBuyerList();
        setIsUpdateOpenModal(false);
        toast.custom(
          <SingleErrorMessage
            data={response.message}
            error={false}
            bColor="#175FC9"
            onClose={onCloseToaste}
          />
        );
      }
    } else {
      toast.custom(
        <SingleErrorMessage
          data={response.message}
          error={true}
          bColor="#D92D20"
          onClose={onCloseToaste}
        />
      );
    }
  };

  const handlePartialCompleteBid = async () => {
    const payload = {
      status: 5,
    };
    const response = await updateBuyerBid(id, payload);
    if (response.status) {
      // navigate("/buyerReqest/list", { state: { id: 2 } });
      navigate("/buyerReqest/inprogress-request");
    } else {
      toast.custom(
        <SingleErrorMessage
          data={response.message}
          error={true}
          bColor="#D92D20"
          onClose={onCloseToaste}
        />
      );
    }
  };

  const bidCancelFormik = useFormik({
    initialValues: {
      status: 6,
      remark: "",
    },
    onSubmit: async (values) => {
      setIsLoading(true);
      const response = await changeWarhouseBidStatus(warehouseId, values);
      if (response.status) {
        if (filteredList == 1) {
          // navigate("/buyerReqest/list", { state: { id: 3 } });
          navigate("/buyerReqest/closed-request");
          handleCompleteWarehouseBid();
        } else {
          fetchBuyerList();
          setIsOpenCancelModal(false);
          toast.custom(
            <SingleErrorMessage
              data={response.message}
              error={false}
              bColor="#175FC9"
              onClose={onCloseToaste}
            />
          );
        }
        bidCancelFormik.handleReset();
      } else {
        toast.custom(
          <SingleErrorMessage
            data={response.message}
            error={true}
            bColor="#D92D20"
            onClose={onCloseToaste}
          />
        );
      }
      setIsLoading(false);
    },
  });
  // const reviceFormik = useFormik({
  //   initialValues: {
  //     id: "",
  //     deliveryDate: "",
  //   },
  //   onSubmit: async (values) => {
  //     values.id = warehouseId;
  //     setReviseData(values);
  //     setIsOpenCanvas(false);
  //     setIsReviseOpenModal(true);
  //     // setIsLoading(true);
  //   },
  // });
  // const handleReviseUpdate = async () => {
  //   setIsLoading(true);
  //   // values.id = warehouseId;
  //   const response = await reviceBuyerReuest(reviseData);
  //   navigate("/buyerReqest/list", { state: { id: 0 } });
  //   if (response.status) {
  //     if (filteredList == 1) {
  //       handleCompleteWarehouseBid();
  //     } else {
  //       fetchBuyerList();
  //       setIsReviseOpenModal(false);
  //       // reviceFormik.handleReset();
  //       toast.custom(
  //         <SingleErrorMessage
  //           data={response.message}
  //           error={false}
  //           bColor="#175FC9"
  //           onClose={onCloseToaste}
  //         />
  //       );
  //     }
  //   } else {
  //     toast.custom(
  //       <SingleErrorMessage
  //         data={response.message}
  //         error={true}
  //         bColor="#D92D20"
  //         onClose={onCloseToaste}
  //       />
  //     );
  //   }
  // };
  useEffect(() => {
    fetchBuyerList(search);
  }, [currentPage, paginationValue, search]);

  useEffect(() => { }, [filteredList]);

  return (
    <div className="payout_data-content">
      <div className="payout_data-head">
        <div className="payout_data-head-top">
          <div className="payout_data-left p-0">
            <div className="payout_data_ttl">
              <Breadcrumb
                paths={[
                  {
                    name: `${handleTitle()} Request List`,
                    link: `/buyerReqest/list`,
                  },
                  {
                    name: "Warehouse Bid List",
                    link: `/buyerRequest/warehouseBid/:id`,
                  },
                ]}
              />
            </div>
          </div>
        </div>
        <div className="search_container mb-4">
          <SearchBox search={search} setSearch={setSearch} />
        </div>
      </div>
      <div className="tab_box">
        <Tabs>
          <TabPanel>
            <div className="scroll_v">
              <table className="payout_table upi-mandate_table">
                <tr className="tableHead">
                  <th className="thHeader">
                    <div className="payoutHead hndIcon">Order ID</div>
                  </th>
                  <th className="thHeader">
                    <div className="payoutHead hndIcon">User Name</div>
                  </th>
                  <th className="thHeader">
                    <div className="payoutHead hndIcon">Order Date</div>
                  </th>
                  <th className="thHeader">
                    <div className="payoutHead">Address</div>
                  </th>

                  <th className="thHeader">
                    <div className="payoutHead">Product</div>
                  </th>
                  <th className="thHeader">
                    <div className="payoutHead">Variety</div>
                  </th>
                  <th className="thHeader">
                    <div className="payoutHead">Grade</div>
                  </th>
                  <th className="thHeader">
                    <div className="payoutHead">MSP </div>
                  </th>
                  <th className="thHeader">
                    <div className="payoutHead">Price </div>
                  </th>
                  <th className="thHeader">
                    <div className="payoutHead">Quantity </div>
                  </th>
                  <th className="thHeader">
                    <div className="payoutHead">Total Price </div>
                  </th>
                  <th className="thHeader">
                    <div className="payoutHead">Delivery Date</div>
                  </th>
                  <th className="thHeader">
                    <div className="payoutHead headerAction">Action </div>
                  </th>
                </tr>
                {isLoading ? (
                  <tr>
                    <td colSpan="9" className="text-center">
                      <Loader />
                    </td>
                  </tr>
                ) : (
                  <>
                    {buyerReuqstList.length > 0 ? (
                      buyerReuqstList.map((item) => {
                        return (
                          <tr>
                            <td className="noWrap">{item.orderId}</td>
                            <td className="phone_number">
                              {item?.warehouse?.name ?? "-"}
                            </td>
                            <td className="phone_number noWrap">
                              {moment(item?.createdAt).format("DD-MM-YYYY")}
                            </td>
                            <td className="Status">
                              <div style={{ width: "200px" }}>
                                {item?.warehouseAddress?.location?.address
                                  ? item?.warehouseAddress?.location?.address
                                  : item?.warehouseDefaultAddress?.location
                                    ?.address ?? "----"}
                              </div>
                            </td>
                            <td className="table_amount ">{item?.product}</td>
                            <td className="table_amount noWrap">
                              {item?.veriety ?? "-"}
                            </td>
                            <td className="table_amount">{item?.grade}</td>
                            <td className="Status">
                              <div>
                                {item?.mspDetails?.minimum_selling_price || ""}/{" "}
                                {item?.mspDetails?.unit?.shortcode || ""}
                              </div>
                            </td>
                            <td className="Status bold_txt">
                              <div className="noWrap">
                                {handleCurrency()}{" "}
                                {item?.warehouseDetails?.price}
                              </div>
                            </td>
                            <td className="Status noWrap bold_txt">
                              <div>
                                {item?.warehouseDetails?.acceptedQty}{" "}
                                {item?.unit}
                              </div>
                            </td>

                            <td nowrap className="Status noWrap bold_txt">
                              {handleCurrency()}{" "}
                              {(item?.warehouseDetails?.price ?? 0) *
                                (item?.warehouseDetails?.acceptedQty ?? 0) *
                                (item?.conversion ?? 0)}
                            </td>
                            <td>
                              {" "}
                              <div className="noWrap">
                                {moment(
                                  item?.warehouseDetails?.deliveryDate
                                ).format("DD-MM-YYYY")}
                              </div>
                            </td>
                            <td>
                              <div className="action_payment addBuyer_submit-btn pd_0">
                                {item?.warehouseDetails?.status === 1 ||
                                  item?.warehouseDetails?.status === 5 ? (
                                  <>
                                    <button
                                      className="btn btn-primary noWrap"
                                      color="light"
                                      variant="primary"
                                      isLight="btn btn-primary"
                                      tag="a"
                                      onClick={() => {
                                        setWarehouseId(
                                          item?.warehouseDetails?._id
                                        );
                                        navigate(
                                          `/buyerRequest/revice/${item?.warehouseDetails?._id}`
                                        );
                                        // checkLastRevice(
                                        //   item?.warehouseDetails?._id
                                        // );
                                        // setIsOpenCanvas(true);
                                        setStatus(2);
                                      }}
                                    >
                                      Revise Request
                                    </button>
                                    {"  "}
                                    <button
                                      className="btn btn-success noWrap"
                                      color="dark"
                                      variant="Secondary"
                                      isLight="btn btn-primary"
                                      tag="a"
                                      onClick={() => {
                                        setWarehouseId(
                                          item?.warehouseDetails?._id
                                        );
                                        setIsUpdateOpenModal(true);
                                        setStatus(2);
                                      }}
                                    >
                                      Complete Request
                                    </button>
                                    <button
                                      className="btn btn-dark noWrap"
                                      color="info"
                                      isLight="btn btn-primary"
                                      tag="a"
                                      onClick={() => {
                                        setWarehouseId(
                                          item?.warehouseDetails?._id
                                        );
                                        // handleCancelBid();
                                        setIsOpenCancelModal(true);
                                        setStatus(3);
                                      }}
                                    >
                                      Cancel Request
                                    </button>
                                  </>
                                ) : item?.warehouseDetails?.status === 3 ? (
                                  "Revised"
                                ) : item?.warehouseDetails?.status === 2 ? (
                                  "Completed"
                                ) : item?.warehouseDetails?.status === 6 ? (
                                  "Cancelled"
                                ) : (
                                  ""
                                )}
                              </div>
                            </td>
                          </tr>
                        );
                      })
                    ) : (
                      <>
                        <tr>
                          <td colSpan="11" className="text_center">
                            No data available
                          </td>
                        </tr>
                      </>
                    )}
                  </>
                )}
              </table>{" "}
            </div>
          </TabPanel>

          <Pagination
            currentPage={currentPage}
            totalCount={totalRecords}
            pageSize={paginationValue}
            onPageChange={(page) => setCurrentPage(page)}
            changePageSize={(page) => {
              setPaginationValue(page);
              setCurrentPage(1);
            }}
          />
        </Tabs>

        {/* cancel bid model */}

        <Modal
          show={isOpenCancelModal}
          onHide={() => {
            setIsOpenCancelModal(false);
            bidCancelFormik.handleReset();
          }}
        >
          <Modal.Header closeButton>
            <Modal.Title>Cancel</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            Are you sure you want to cancel the request?
            <div className="add_buyer_content">
              <form action="" onSubmit={bidCancelFormik.handleSubmit}>
                <div className="row">
                  <div className="col-lg-12">
                    <div className="input-box">
                      <div className="input-label">
                        Remark
                        <span>*</span>
                      </div>
                      <div className="input_field">
                        <input
                          type="text"
                          className="input"
                          name="remark"
                          placeholder="Enter remark"
                          required
                          value={bidCancelFormik.values.remark}
                          onChange={bidCancelFormik.handleChange}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <Modal.Footer>
                  <div className="mt-3 flex_btn">
                    <button
                      className="btn btn-dark"
                      type="button"
                      onClick={() => {
                        setIsOpenCancelModal(false);
                        bidCancelFormik.handleReset();
                      }}
                    >
                      No
                    </button>
                    <button className="btn btn-success" type="submit">
                      Yes
                    </button>
                  </div>
                </Modal.Footer>
              </form>
            </div>
          </Modal.Body>
        </Modal>

        {/* complet bid model */}
        <Modal
          show={isUpdateOpenModal}
          onHide={() => {
            setIsUpdateOpenModal(false);
          }}
        >
          <Modal.Header closeButton>
            <Modal.Title>Complete</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            Are you sure you want to complete the request?
          </Modal.Body>
          <Modal.Footer>
            <button
              className="btn btn-dark"
              variant="secondary"
              onClick={() => {
                setIsUpdateOpenModal(false);
              }}
            >
              No
            </button>
            <button
              className="btn btn-success"
              variant="primary"
              onClick={handleUpdateBid}
            >
              Yes
            </button>
          </Modal.Footer>
        </Modal>

        {/* Revice Buyer Request Off Canvas */}
        {/* <Offcanvas
          show={isOpenCanvas}
          onHide={() => {
            setIsOpenCanvas(false);
            // reviceFormik.handleReset();
          }}
          placement="end"
        >
          <Offcanvas.Header closeButton>
            <Offcanvas.Title>Revise Request</Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <div className="add_buyer_content">
              <form
                action=""
                // className="payment_form"
                onSubmit={reviceFormik.handleSubmit}
              >
                <div className="row">
                  <div className="col-lg-12">
                    <div className="input-box">
                      <div className="input-label">Delivery Date</div>
                      <div className="input_field">
                        <input
                          className="input"
                          required
                          name="deliveryDate"
                          type="date"
                          placeholder="select date"
                          value={reviceFormik.values.deliveryDate}
                          min={moment(new Date()).format("YYYY-MM-DD")}
                          onChange={reviceFormik.handleChange}
                          // onKeyDown={(e) => e.preventDefault()}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="mt-3 flex_btn">
                  <button className="btn btn-success" type="submit">
                    Save
                  </button>
                </div>
              </form>
            </div>
          </Offcanvas.Body>
        </Offcanvas> */}
      </div>
    </div>
  );
};
